/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React, { PureComponent } from 'react';
import { fieldPropTypes } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

import RichTextField from 'components/RichTextField';

// assets
import CssField from '../Field.scss';
import CssTextarea from './RichTextarea.scss';

class RichTextarea extends PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.input.value || '',
      isFocused: false,
    };

    this.bindings = {
      handleChange: this.handleChange.bind(this),
      handleFocus: this.handleFocus.bind(this),
      handleBlur: this.handleBlur.bind(this),
    };
  }

  handleChange(htmlContent) {
    this.setState({ inputValue: htmlContent });
    this.props.input.onChange(htmlContent);
  }

  handleFocus() {
    this.setState({
      isFocused: true,
    });
    this.props.input.onFocus();
  }

  handleBlur() {
    this.setState({
      isFocused: false,
    });
    this.props.input.onBlur();
  }

  render() {
    const {
      input: { name, value },
      label,
      meta: { form, dirty },
    } = this.props;
    const { inputValue, isFocused } = this.state;
    const id = `${form}-${name}`;

    return (
      <div className="field field--textarea">
        <div className="field__wrapper">
          <RichTextField
            placeholder={label}
            handleReviewChange={this.bindings.handleChange}
            isDirty={dirty}
            isOpen
            review={value}
            minLength={0}
            onFocus={this.bindings.handleFocus}
            handleBlur={this.bindings.handleBlur}
            focused={isFocused}
          />
          <textarea id={id} className="hidden-input" name={name} value={inputValue} />
        </div>
      </div>
    );
  }
}

export default withStyles(CssField, CssTextarea)(RichTextarea);
